import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';

import OurStrengths from './pages/OurStrengths';
import Careers from './pages/Careers';
import Downloads from './pages/Downloads';

import Gallery from './pages/Gallery';
import Awards from './pages/Awards';
import NewsMedia from './pages/NewsMedia';
import NewsDetail from './pages/NewsDetail';
import ProductDetail from './pages/ProductDetail';
import Administration from './pages/departments/Administration';
import Accounts from './pages/departments/Accounts';
import LabourTime from './pages/departments/LabourTime';
import Engineering from './pages/departments/Engineering';
import CaneDevelopment from './pages/departments/CaneDevelopment';
import Purchase from './pages/departments/Purchase';
import Godown from './pages/departments/Godown';
import Security from './pages/departments/Security';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';

import { DataProvider } from './context/DataContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminLayout from './admin/AdminLayout';
import Dashboard from './admin/Dashboard';
import AdminAbout from './admin/AdminAbout';
import AdminGrowthStats from './admin/AdminGrowthStats';
import AdminProducts from './admin/AdminProducts';
import AdminStrengths from './admin/AdminStrengths';
import AdminNews from './admin/AdminNews';
import AdminAwards from './admin/AdminAwards';
import AdminGallery from './admin/AdminGallery';
import AdminLogin from './admin/AdminLogin';
import AdminInquiries from './admin/AdminInquiries';
import AdminDivisions from './admin/AdminDivisions';
import AdminDownloads from './admin/AdminDownloads';
import AdminCareers from './admin/AdminCareers';

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  if (!currentUser) return <Navigate to="/admin/login" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Admin Login */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Protected Admin Routes */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="about" element={<AdminAbout />} />
              <Route path="growth-stats" element={<AdminGrowthStats />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="strengths" element={<AdminStrengths />} />
              <Route path="news" element={<AdminNews />} />
              <Route path="awards" element={<AdminAwards />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="divisions" element={<AdminDivisions />} />
              <Route path="downloads" element={<AdminDownloads />} />
              <Route path="careers" element={<AdminCareers />} />
              <Route path="inquiries" element={<AdminInquiries />} />
            </Route>

            {/* User Routes */}
            <Route path="*" element={
              <div className="flex flex-col min-h-screen">
                <Navbar />
                <main className="flex-grow">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/our-strengths" element={<OurStrengths />} />
                    <Route path="/careers" element={<Careers />} />
                    <Route path="/downloads" element={<Downloads />} />
                    <Route path="/news" element={<NewsMedia />} />
                    <Route path="/news/:id" element={<NewsDetail />} />
                    <Route path="/contact" element={<Contact />} />

                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/awards" element={<Awards />} />
                    <Route path="/products/:id" element={<ProductDetail />} />
                    <Route path="/departments/administration" element={<Administration />} />
                    <Route path="/departments/accounts" element={<Accounts />} />
                    <Route path="/departments/labour-time" element={<LabourTime />} />
                    <Route path="/departments/engineering" element={<Engineering />} />
                    <Route path="/departments/cane-development" element={<CaneDevelopment />} />
                    <Route path="/departments/purchase" element={<Purchase />} />
                    <Route path="/departments/godown" element={<Godown />} />
                    <Route path="/departments/security" element={<Security />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            } />
          </Routes>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
